import * as React from "react";
import { useLocation, useParams } from "wouter";

export function useUrlParam<T extends string>(param: T) {
  const { [param]: paramValue } = useParams<Record<string, string>>();
  const [, navigate] = useLocation();

  const setValue = React.useCallback(
    (newValue: string) => {
      navigate(window.location.pathname.replace(paramValue, newValue));
    },
    [navigate, paramValue],
  );

  return [paramValue, setValue] as const;
}
